<script>
import pick from 'lodash/pick'
import keys from 'lodash/keys'
import {
  notificationComputed,
  notificationMethods,
} from '@state/helpers/notification'
import { NOTIFICATION_STATUS_NAME, NOTIFICATION_STATUS } from '@utils/constant'
export default {
  props: {
    variant: {
      validator: function(value) {
        return !!~['add', 'edit'].indexOf(value)
      },
      default: 'add',
    },
    errors: {
      type: Object,
      default: () => {},
    },
    triggerMask: {
      type: Boolean,
      require: false,
    },
  },
  data() {
    return {
      fields: {
        schedule_start: '',
        schedule_end: '',
      },
      editable: false, // edit mode
    }
  },
  computed: {
    ...notificationComputed,
    add() {
      return this.variant === 'add'
    },
    hiddenEditButton() {
      if (
        NOTIFICATION_STATUS[this.getNotificationDetail?.status] ===
        NOTIFICATION_STATUS[1]
      ) {
        return true
      }
      return (
        this.add ||
        (!this.add &&
          ![
            NOTIFICATION_STATUS_NAME.WAITING_FOR_DELIVERY,
            NOTIFICATION_STATUS_NAME.DELIVERY,
          ].includes(this.getNotificationDetail?.status))
      )
    },
  },
  watch: {
    getNotificationDetail() {
      if (this.getNotificationDetail) {
        this.initDeliveryPeriodData()
      }
    },
  },
  methods: {
    ...notificationMethods,
    initDeliveryPeriodData() {
      const detail = { ...this.getNotificationDetail }
      if (this.add) {
        return
      }
      this.fields = pick(detail, keys(this.fields))
    },
    handleChangeScheduleDate(value) {
      this.fields.schedule_start = value.date_start
      this.fields.schedule_end = value.date_end
      this.$emit('change:data', this.fields)
    },
    toggleEditable() {
      this.editable = !this.editable
      this.initDeliveryPeriodData()
      this.$emit('enable:edit', this.editable)
    },
  },
}
</script>

<template>
  <div id="notification-delivery">
    <BaseCardDetail
      title="配信期間"
      form-collapsed
      :errors="errors"
      :has-footer="!add && editable"
      :trigger-mask="!editable && triggerMask"
      @edit="toggleEditable"
      @cancel="toggleEditable"
      @submit="
        () => {
          toggleEditable()
          $emit('edit:notification')
        }
      "
    >
      <template v-if="hiddenEditButton" v-slot:header-action>
        <div />
      </template>
      <CRow>
        <CCol sm="3" class="d-flex align-items-center">
          <div class="col-form-label">
            期間
            <span class="text-danger">*</span>
          </div>
        </CCol>
        <CCol sm="9">
          <BaseDateRangerPicker
            vee-name-start="schedule_start"
            vee-name-end="schedule_end"
            :rules="{ required: true }"
            :rules-start="{ timeAfterNow: true }"
            picker-type="datetime"
            :start-date="fields.schedule_start"
            :end-date="fields.schedule_end"
            :disabled="!add && !editable"
            @update:value="handleChangeScheduleDate"
          />
        </CCol>
      </CRow>
    </BaseCardDetail>
  </div>
</template>
